module.exports = __webpack_public_path__ + "img/tutorial.c39670c3.svg";